G.TreasureHunt = G.TreasureHunt || {};

G.TreasureHunt.treasureHuntMgr = (function() {
  // imports
  var saveStateMgr = null;
  var levelDataMgr = null;

  var treasureHuntConfig = null;

  var saveData = null;
  var eventInstanceData = null;
  var readyToStart = false;
  var isLevelActive = false;
  var levelGemCounter = 0;

  var dayMs = 1000*60*60*24;

  var invitesCap = null;
  var gemsTargets = null;
  var refractorPeriod = null;
  var eventDuration = null;

  var onInvitesIncrease = new Phaser.Signal();
  var onEventStart = new Phaser.Signal();
  var onEventCompleted = new Phaser.Signal();
  var onEventExpired = new Phaser.Signal();
  var onEventTurnedOnChange = new Phaser.Signal();
  var onLevelComplete = new Phaser.Signal();

  return {
    init: init,
    isFeatureUnlocked: isFeatureUnlocked,
    isEventActive: isEventActive,
    isEventReadyToStart: isEventReadyToStart,
    isEventTurnedOn: isEventTurnedOn,
    startEvent: startEvent,
    isLevelTreasureHuntActive: isLevelTreasureHuntActive,
    isRewardAvailable: isRewardAvailable,
    markRewardAsClaimed: markRewardAsClaimed,
    startLevel: startLevel, 
    failLevel: failLevel,
    completeLevel: completeLevel,
    collectGem: collectGem,
    getLevelCollectedGems: getLevelCollectedGems,
    getProgressData: getProgressData,
    getProgressPercent: getProgressPercent,
    getGeneralEventInfo: getGeneralEventInfo,
    getInvitesCap: getInvitesCap,
    getTreasureHuntLevelIndex: getTreasureHuntLevelIndex,
    getInvitedContexts: getInvitedContexts,
    addInvitedContext: addInvitedContext,
    //sendInvite: sendInvite,
    getGemsTarget: getGemsTarget,
    getMainReward: getMainReward,
    getChestDropOverwrite: getChestDropOverwrite,
    setConfig: setConfig,

    onInvitesIncrease: onInvitesIncrease,
    onEventStart: onEventStart,
    onEventCompleted: onEventCompleted,
    onEventExpired: onEventExpired,
    onEventTurnedOnChange: onEventTurnedOnChange,
    onLevelComplete: onLevelComplete,
  };

  function init(config) {
    // imports
    saveStateMgr = G.saveState;
    levelDataMgr = G.Helpers.levelDataMgr;
    gatesMgr = G.Helpers.gatesMgr;

    saveData = G.Utils.defined(saveStateMgr.getTreasureHuntData(), {
      gateOpened: false,
    });
    eventInstanceData = saveData.eventInstanceData;

    gatesMgr.signals.onGateOpened.addOnce(onGateOpened);

    setConfig(config);

    setupExpiredEvent();
  };

  function setConfig(config) {
    treasureHuntConfig = config;

    gemsTargets = G.Utils.defined(config.gemsTargets, [{
      afterLevel: 0,
      target: 200,
    }]);
    eventDuration = G.Utils.defined(config.eventDurationDays, 3) * dayMs;
    refractorPeriod = G.Utils.defined(config.refractorPeriodDays, 1) * dayMs;
    invitesCap = G.Utils.defined(config.invitesCap, 3);
  }

  function getMainReward() {
    return treasureHuntConfig.mainReward;
  }

  function getChestDropOverwrite() {
    return treasureHuntConfig.chestDropOverwrite;
  }

  function setupExpiredEvent() {
    if (!eventInstanceData) return;
    if (eventInstanceData.onTimeEndCalled) return;

    if (isEventActive()) {
      var delay = (eventInstanceData.endTime-Date.now())+10;
      console.log("TH Delay ", delay);
      setTimeout(onTimeEnd, delay);
    } else {
      onTimeEnd();
    }

    function onTimeEnd() {
      onEventTurnedOnChange.dispatch(false);
      console.log("TH on time end");
      eventInstanceData.onTimeEndCalled = true;
      if (!isGoalAchieved()) {
        onEventExpired.dispatch(getProgressData());
      }
      save();
    }
  };

  function startEvent() {
    if (!isEventReadyToStart()) return;

    eventInstanceData = {
      startTime: Date.now(),
      endTime: Date.now()+(eventDuration),
      gemsCollected: 0,
      gemsTarget: getGemsTarget(),
      invitedContexts: [],
      rewardClaimed: false,
      newGateLock: true,
    };
    saveData.eventInstanceData = eventInstanceData;
    onEventStart.dispatch();
    onEventTurnedOnChange.dispatch(true);
    save();
  };

  function save() {
    saveStateMgr.saveTreasureHuntData(saveData);
  };

  function onGateOpened() {
    if (!saveData.gateOpened) {
      saveData.gateOpened = true;
      save();
    }

    if (eventInstanceData) {
      eventInstanceData.newGateLock = false;
    }

    onEventTurnedOnChange.dispatch(isEventTurnedOn());
  }

  function isFeatureUnlocked() {
    // check if first gate is open
    return saveData.gateOpened;
  };

  function isUserCandidateForNewEvent() {
     var lastPassedIndex = saveStateMgr.getLastPassedLevelNr();
    return (isFeatureUnlocked()
      && lastPassedIndex <= levelDataMgr.getNumberOfLevels() - 40);
  };

  function isEventTurnedOn() {
    return isEventActive() || isEventReadyToStart();
  };

   function isEventReadyToStart() {
    if (isEventActive()) return false;
    if (isEventOnCooldown()) return false;
    if (eventInstanceData) {
      if (eventInstanceData.newGateLock) {
        return false;
      }
    }

    return isUserCandidateForNewEvent();
  };

  function isEventActive() {
    if (!eventInstanceData) return false;
    return Date.now() < eventInstanceData.endTime
      && eventInstanceData.gemsCollected < eventInstanceData.gemsTarget
      && !isGoalAchieved();
  };

  function isEventOnCooldown() {
    if (!eventInstanceData) return false;
    return Date.now() < eventInstanceData.endTime+refractorPeriod
      && (Date.now() > eventInstanceData.endTime || isGoalAchieved());
  };

  function getProgressData() {
    if (!eventInstanceData) return null;

    return {
      gemsCollected: eventInstanceData.gemsCollected,
      gemsTarget: eventInstanceData.gemsTarget,
      endDate: eventInstanceData.endTime,
      rewardClaimed: eventInstanceData.rewardClaimed,
      invitedContexts: getInvitedContexts(),
    };
  };

  function getProgressPercent() {
    if (!eventInstanceData) return 0;
    const progressPercent = Math.round(eventInstanceData.gemsCollected / eventInstanceData.gemsTarget * 100);
    return !(isNaN(progressPercent) || !isFinite(progressPercent) || progressPercent === null) ? progressPercent : 0;
  };

  function getGemsTarget() {
    var passedLevel = saveStateMgr.getLastPassedLevelNr();

    gemsTargets.sort(function(a,b){
      return b.afterLevel > a.afterLevel;
    });

    var targetConfig = gemsTargets.find(function(config) {
      return config.afterLevel <= passedLevel;
    });

    if (targetConfig) {
      return targetConfig.target;
    } else {
      return 200;
    }
  }

  function getGeneralEventInfo() {
    return {
      gemsTarget: getGemsTarget(),
      duration: eventDuration,
      durationDays: Math.ceil(eventDuration/dayMs),
    };
  };

  function isLevelTreasureHuntActive(lvlIndex) {
    if (!isEventActive()) return false;

    var currentLvlIndex = saveStateMgr.getLastPassedLevelNr();
    return lvlIndex === currentLvlIndex || lvlIndex === levelDataMgr.getMaxLevelIndex();
  };

  function getTreasureHuntLevelIndex() {
    var lastLvlIndex = Math.min(
      levelDataMgr.getMaxLevelIndex(), saveStateMgr.getLastPassedLevelNr())

    if (isLevelTreasureHuntActive(lastLvlIndex)) {
      return lastLvlIndex;
    } else {
      return null;
    }
  };

  function startLevel(lvlIndex) {
    if (isLevelTreasureHuntActive(lvlIndex)) {
      levelGemCounter = 0;
    }
  };

  function completeLevel(lvlIndex) {
    var gainedGems = levelGemCounter;
    onLevelComplete.dispatch(lvlIndex, gainedGems);

    if (isLevelTreasureHuntActive(lvlIndex)) {
      eventInstanceData.gemsCollected = Math.min(
        eventInstanceData.gemsCollected+levelGemCounter,
        eventInstanceData.gemsTarget);
      if (isGoalAchieved()) {
        eventInstanceData.endTime = Date.now();
        onEventCompleted.dispatch(getProgressData());
        onEventTurnedOnChange.dispatch(false);
      }
      save();
    }
    levelGemCounter = 0;

    return gainedGems;
  };

  function isGoalAchieved() {
    if (!eventInstanceData) return false;
    return eventInstanceData.gemsCollected >= eventInstanceData.gemsTarget;
  }; 

  function isRewardAvailable() {
    if (!eventInstanceData) return false;
    if (isGoalAchieved() && !eventInstanceData.rewardClaimed) {
      return true;
    } else {
      return false;
    }
  };

  function markRewardAsClaimed() {
    if (!eventInstanceData) return false;
    eventInstanceData.rewardClaimed = true;
    save();
  };

  function failLevel(lvlIndex) {
    levelGemCounter = 0;
  };

  function collectGem() {
    levelGemCounter++;
  };

  function getLevelCollectedGems() {
    return levelGemCounter;
  };

  function getInvitedContexts() {
    if (!eventInstanceData || !eventInstanceData.invitedContexts) return [];
    // in case inviteCap was changed durign event
    // slice array
    return eventInstanceData.invitedContexts.slice(0, getInvitesCap());
  };

  function addInvitedContext(contextId) {
    if (!eventInstanceData) return null;
    eventInstanceData.invitedContexts.push(contextId);
    onInvitesIncrease.dispatch(getInvitedContexts().length);
    save();
  };

  function getInvitesCap() {
    return invitesCap;
  };

  /*
  // TODO: review later on for re-implementation
  function sendInvite(optCallback) {
    // imports
    var platform = G.platform;

    var invitedContexts = getInvitedContexts();
    if (invitedContexts.length === invitesCap) return;

    platform.sendTreasureHuntInvite(function(success, contextId) {
        if (success) {
          addInvitedContext(contextId);
          if (optCallback) optCallback(true)
        } else {
          if (optCallback) optCallback(false);
        }
    }, invitedContexts);
  };
  */

})();